import { render } from "./VideoReportingInfo.vue?vue&type=template&id=3d1487f6"
import script from "./VideoReportingInfo.vue?vue&type=script&lang=js"
export * from "./VideoReportingInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__